import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import {
  CCASSQueryDetailsResponse,
  CCASSShareholdingDetail,
  CCASSSummary,
} from '../../../py-generated/datalouder/ccass/types';
import ShareholdingChangeChart from './ShareholdingChangeChart';
import ShareholdingPieChart from './ShareholdingPieChart';

interface Props {
  querySummary: CCASSSummary;
  queryDetails: CCASSShareholdingDetail[];
  compareSummary?: CCASSSummary;
  compareDetails?: CCASSShareholdingDetail[];
  participants: CCASSQueryDetailsResponse['participants'];
}

const CCASSShareholdingCharts: React.FC<Props> = ({
  querySummary,
  queryDetails,
  compareSummary,
  compareDetails,
  participants,
}) => {
  return (
    <Row>
      <Col md={4}>
        <ShareholdingPieChart
          shareholdingSummary={querySummary}
          shareholdingDetails={queryDetails}
          participants={participants}
        />
      </Col>
      {compareSummary && compareDetails && (
        <Col md={4}>
          <ShareholdingChangeChart
            querySummary={querySummary}
            queryDetails={queryDetails}
            compareSummary={compareSummary}
            compareDetails={compareDetails}
            participants={participants}
            desc
          />
        </Col>
      )}
      {compareSummary && compareDetails && (
        <Col md={4}>
          <ShareholdingChangeChart
            querySummary={querySummary}
            queryDetails={queryDetails}
            compareSummary={compareSummary}
            compareDetails={compareDetails}
            participants={participants}
          />
        </Col>
      )}
    </Row>
  );
};

export default CCASSShareholdingCharts;
